import { getNumberFromString } from '@utils/amount';

import { RoundCreateForm } from '../types';

const formatDataForRoundCreation = (
  data: RoundCreateForm,
  valuationType: string,
  getUtcDateWithTimeZone: (date: Date) => string,
  dealId?: string
) => {
  return {
    round_name: data.roundName ?? '',
    company_stage: data.companyStage ?? '',
    size: data.size ? parseInt(getNumberFromString(data.size)) : 0,
    round_date: getUtcDateWithTimeZone(new Date(data.roundDate)) ?? '',
    valuation_type: valuationType ?? '',
    valuation: data.valuation
      ? parseInt(getNumberFromString(data.valuation))
      : 0,
    convertible_debts: data.convertibleTerms ?? '',
    ...(dealId && { deal_id: dealId }),
    ...(data.markupType && {
      markup_type: data.markupType,
      markup_percentage:
        data.markupPercentage && !isNaN(parseFloat(data.markupPercentage))
          ? parseFloat(data.markupPercentage)
          : undefined
    })
  };
};

const formatDataForValuation = (
  data: RoundCreateForm,
  getUtcDateWithTimeZone: (date: Date) => string
) => {
  return {
    round_date: getUtcDateWithTimeZone(new Date(data.roundDate)),
    valuation: data.valuation
      ? parseInt(getNumberFromString(data.valuation))
      : undefined
  };
};

export { formatDataForRoundCreation, formatDataForValuation };
